import * as React from "react";
import ActivityTagsList from "./ActivityTagsList";
import EditActivityTag from "./EditActivityTag";
import EventType from "components/Setting/EventType";
import { addActivityTag } from "services/activityTagService";

const ActivityTags = (props) => {
  return (
    <EventType
      open={props.open}
      close={props.close}
      apiAddFunc={addActivityTag}
      buttonLabel="Activity Tags"
      listComponent={ActivityTagsList}
      editFormComponent={EditActivityTag}
      component="activityTags"
    />
  );
};

export default ActivityTags;
